module.exports = __webpack_public_path__ + "img/Duettes.c0930d04.png";